<template>
  <div class="home">
    <el-carousel class="banner" arrow="hover" :interval="5000">
      <el-carousel-item>
        <img src="../assets/img/banner.jpg" class="img-fluid" />
      </el-carousel-item>
    </el-carousel>
    <section class="text-center">
      <div class="row no-gutters">
        <div class="features-card col-lg-3 u-bg-overlay g-bg-img-hero g-bg-cyan-opacity-0_9--after g-color-white text-center g-pa-60">
          <router-link to="/process" class="g-color-white">
            <div class="u-bg-overlay__inner">
              <h3 class="h5 text-uppercase g-font-weight-600 g-mb-15">一站式自助跨境郵包投寄</h3>
              <p class="g-font-size-16 g-mb-20">
                準備好郵包後, 用手機下載【智郵易】手機應用程式進入下單平台， 跟著步驟輸入資料後，上載所需文件，成功申請郵包號並完成線上支付費用 後，自行到指定投寄點投遞便可。
              </p>
              <p class="g-font-size-16">（使用【智郵易】投寄郵包均屬國際郵包，受海關監控並需申報及清關）</p>
            </div>
          </router-link>
        </div>
        <div class="features-card col-lg-3 u-bg-overlay g-bg-img-hero g-bg-purple-opacity-0_9--after g-color-white text-center g-pa-60">
          <router-link to="/price" class="g-color-white">
            <div class="u-bg-overlay__inner">
              <!--<span class="u-icon-v2 u-icon-size&#45;&#45;lg u-shadow-v24 rounded-circle g-mb-25">-->
              <!--<i class="icon-finance-196 u-line-icon-pro"></i>-->
              <!--</span>-->
              <h3 class="h5 text-uppercase g-font-weight-600 g-mb-15">由投寄至派送</h3>
              <p class="g-font-size-16 g-mb-20">
                全程物流追蹤 軌跡節點詳盡
              </p>
            </div>
          </router-link>
        </div>
        <div class="features-card col-lg-3 u-bg-overlay g-bg-img-hero g-bg-cyan-opacity-0_9--after g-color-white text-center g-pa-60">
          <router-link to="/faq" class="g-color-white">
            <div class="u-bg-overlay__inner">
              <!--<span class="u-icon-v2 u-icon-size&#45;&#45;lg u-shadow-v24 rounded-circle g-mb-25">-->
              <!--<i class="icon-finance-147 u-line-icon-pro"></i>-->
              <!--</span>-->
              <h3 class="h5 text-uppercase g-font-weight-600 g-mb-15">空運頭程服務</h3>
              <p class="g-font-size-16 g-mb-20">
                節省海/陸運運輸時效
              </p>
            </div>
          </router-link>
        </div>
        <div class="features-card col-lg-3 u-bg-overlay g-bg-img-hero g-bg-teal-opacity-0_9--after g-color-white text-center g-pa-60">
          <router-link to="/faq" class="g-color-white">
            <div class="u-bg-overlay__inner">
              <!--<span class="u-icon-v2 u-icon-size&#45;&#45;lg u-shadow-v24 rounded-circle g-mb-25">-->
              <!--<i class="icon-finance-147 u-line-icon-pro"></i>-->
              <!--</span>-->
              <h3 class="h5 text-uppercase g-font-weight-600 g-mb-15">可投寄品類範圍廣</h3>
              <p class="g-font-size-16 g-mb-20">
                包括 : 健康食品﹑美妝貨品
              </p>
            </div>
          </router-link>
        </div>
        <!-- End Icon Blocks -->
      </div>
    </section>
    <!-- 全新手機下單 -->
    <section class="container g-py-100">
      <div class="text-center g-mb-70">
        <h2 class="h1 g-color-black g-font-weight-600">手機下單 直送全國</h2>
        <!--<p class="lead">方便！快捷！易用！</p>-->
      </div>

      <!--<div class="row justify-content-md-center">-->
        <!--<div class="col-md-8 col-sm-12">-->
          <!--<img src="../assets/img/eSmartship20220311-FB.jpg" class="img-fluid" />-->
        <!--</div>-->
      <!--</div>-->
      <div class="row" style="text-align: center">
        <div class="col-md-6 g-mb-80">
          <img class="img-fluid" src="../assets/img/WhatsApp90694873.png" alt="全新手機下單"  style="width: 200px;">
		  <!--<img class="img-fluid" src="../assets/img/eSSWechat.jpg" alt="全新手機下單"  style="width: 200px;">-->
          <!--<span class="u-icon-v3 g-color-primary g-bg-primary-opacity-0_1 rounded-circle g-mb-25">-->
              <!--<i class="icon-education-089 u-line-icon-pro"></i>-->
            <!--</span>-->
          <!--<div class="d-inline-block g-width-70 g-height-2 g-bg-primary g-pos-rel g-top-5 g-right-minus-25 g-mr-minus-20"></div>-->
          <!--<h2 class="h5 g-color-black g-font-weight-600 mb-3">【智郵易】微信小程序</h2>-->
          <!--<h2 class="h5 g-color-black g-font-weight-600 mb-3">
            請用手機登入【智郵易】微信公眾號<br>
            沒有註冊微信？ 請下載手機版微信</h2>-->
        </div>
        <div class="col-md-6 mt-auto g-mb-80">
          <!--<div class="d-inline-block g-width-70 g-height-2 g-bg-brown g-pos-rel g-top-5 g-left-minus-25 g-mr-minus-20"></div>-->
          <!--<span class="u-icon-v3 g-color-brown g-bg-brown-opacity-0_1 rounded-circle g-mb-25">-->
              <!--<i class="icon-education-088 u-line-icon-pro"></i>-->
            <!--</span>-->
          <img class="img-fluid" src="https://file.e-smartship.com/app-download-qrcode-v2.png" alt="全新手機下單" style="width: 200px;">
          <h2 class="h5 g-color-black g-font-weight-600 mb-3">【智郵易】手機應用程式</h2>
          <a class="h5 g-color-black g-font-weight-600 mb-3" href="https://b.link/eSmartshipApp_1.1.7" target="_blank">下載 : https://b.link/eSmartshipApp_1.1.7</a>
        </div>
      </div>

      <div class="row" style="text-align: center">
        <div class="col-md-12 mt-auto g-mb-30">
          <h2 class="h5 g-color-black g-font-weight-600 mb-3">【智郵易】聯絡查詢 : </h2>
          <h2 class="h5 g-color-black g-font-weight-600 mb-3">
            · 線上客服：【智郵易】微信公眾號<br>
            · 電話客服：2275 1314 (服務時間：星期一至五早上 10 時至下午 6 時)<br>
            · WhatsApp 客服：<a target="_blank" href="https://wa.me/85290694873">https://wa.me/85290694873</a>
          </h2>
        </div>
        <!--<div class="col-md-6 mt-auto g-mb-30">-->
          <!--<img class="img-fluid" src="../assets/img/WhatsApp90694873.png" alt="全新手機下單"  style="width: 200px;">-->
        <!--</div>-->
      </div>

    </section>
    <!-- 服務地點 -->
    <!--<section class="container g-py-100">-->
      <!--<div class="text-center g-mb-50">-->
        <!--<h2 class="h1 g-color-black g-font-weight-600">智郵易服務地點</h2>-->
        <!--<p class="lead">已加盟店鋪</p>-->
        <!--<post-offices-list />-->
      <!--</div>-->

    <!--</section>-->
  </div>
</template>

<script>
// import PostOfficesList from '../components/PostOfficesList';

export default {
  name: 'home',
  components: {
    // PostOfficesList,
  },
};
</script>

<style lang="scss">
  .home {
    .banner {
      // Small devices (landscape phones, 576px and up)
      @media (min-width: 576px) {
        .el-carousel__container {
          height: 230px;
        }
      }

      // Medium devices (tablets, 768px and up)
      @media (min-width: 768px) {
        .el-carousel__container {
          height: 430px;
        }
      }

      // Large devices (desktops, 992px and up)
      @media (min-width: 992px) {
        .el-carousel__container {
          height: 560px;
        }
      }

      // Extra large devices (large desktops, 1200px and up)
      @media (min-width: 1200px) {
        .el-carousel__container {
          height: 1080px;
        }
      }
    }

    .features-card {
      padding-top: 15.28571rem !important;
      &:nth-child(1) {
        background-image: url(../assets/img/ESS-mobile.jpg);
      }
      &:nth-child(2) {
        background-image: url(../assets/img/ESS-tracking.jpg);
      }
      &:nth-child(3) {
        background-image: url(../assets/img/ESS-plane.jpg);
      }
      &:nth-child(4) {
        background-image: url(../assets/img/ESS-export.jpg);
      }
      a {
        text-decoration: none;
      }
    }
  }
</style>
